import { apiFetch } from "@/shared/api/http";

export interface RankingAluno {
  posicao: number;
  alunoId: string;
  nomeExibicao: string;
  fotoUrl?: string;
  faixa?: string | null;
  treinos: number;
  frequenciaPercentual: number;
  souEu: boolean;
}

export interface ConquistaAluno { codigo:string; titulo:string; descricao:string; desbloqueada:boolean; selo?:string|null; destaque?:boolean; configuravel?:boolean; }
export interface DestaqueGamificacao { codigo:string; titulo:string; nomeExibicao:string; valor:string; descricao:string; }

export interface NivelGamificacao {
  nivel: number;
  titulo: string;
  xpAtual: number;
  xpInicioNivel: number;
  xpProximoNivel: number;
  progressoPercentual: number;
}

export interface TemporadaGamificacaoAluno {
  id: string;
  nome: string;
  descricao?: string | null;
  dataInicio: string;
  dataFim: string;
  diasRestantes: number;
  progressoPeriodoPercentual: number;
  desafiosConcluidos: number;
  totalDesafios: number;
}

export interface HistoricoGamificacaoAluno {
  temporadaId: string;
  nome: string;
  dataInicio: string;
  dataFim: string;
  treinos: number;
  frequenciaPercentual: number;
  posicaoFinal: number;
  totalParticipantes: number;
}

export interface DesafioGamificacaoAluno {
  id: string;
  titulo: string;
  descricao?: string | null;
  tipo: "QuantidadeTreinos" | "FrequenciaPercentual" | "SequenciaTreinos" | string;
  meta: number;
  progressoAtual: number;
  progressoPercentual: number;
  concluido: boolean;
  dataInicio: string;
  dataFim: string;
  escopo: string;
  temporadaId?: string | null;
  temporadaNome?: string | null;
  recompensaSimbolica?: string | null;
  selo?: string | null;
  destaque: boolean;
}

export interface ResumoCompetitivoGamificacao {
  participacoes: number;
  lutas: number;
  vitorias: number;
  podios: number;
  ouros: number;
  xp: number;
}

export interface TendenciaMensalGamificacao {
  periodo: string;
  treinos: number;
  registros: number;
  frequenciaPercentual: number;
}

export interface GamificacaoAluno {
  periodo: string;
  treinosNoMes: number;
  frequenciaPercentual: number;
  sequenciaAtual: number;
  melhorSequencia: number;
  minhaPosicao: number;
  totalParticipantes: number;
  totalTreinosHistorico: number;
  competicoes: ResumoCompetitivoGamificacao;
  nivel: NivelGamificacao;
  ranking: RankingAluno[];
  conquistas: ConquistaAluno[];
  destaques: DestaqueGamificacao[];
  desafios: DesafioGamificacaoAluno[];
  temporada?: TemporadaGamificacaoAluno | null;
  historico: HistoricoGamificacaoAluno[];
  tendenciaMensal: TendenciaMensalGamificacao[];
}

export function fetchGamificacaoAluno() {
  return apiFetch<GamificacaoAluno>("/api/app/aluno/gamificacao");
}

export function fetchGamificacaoDependente(studentId: string) {
  return apiFetch<GamificacaoAluno>(`/api/app/responsavel/alunos/${encodeURIComponent(studentId)}/gamificacao`);
}
